/**
 * Scroll-up reveal toolbar that opens the collection menu-drawer (same as mobile filter button).
 */
class CollectionStickyToolbar extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    this.showDesktop = this.dataset.showDesktop === 'true';
    this.lastScrollY = window.scrollY;
    this.pastFacets = false;
    this.menuDrawerOpen = false;

    if (!this.button) return;

    this.boundScroll = this.onWindowScroll.bind(this);
    this.boundClick = this.onButtonClick.bind(this);
    this.boundDocumentClick = this.onDocumentClick.bind(this);

    const facetsRoot = document.getElementById('main-collection-filters');
    if (!facetsRoot) {
      this.hidden = true;
      return;
    }

    this.facetsRoot = facetsRoot;

    this.observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (!entry) return;
        const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        this.pastFacets = scrolledPast;
        if (!this.pastFacets) {
          this.classList.remove('collection-sticky-toolbar--revealed');
        }
      },
      { threshold: 0, rootMargin: '0px 0px -1px 0px' }
    );
    this.observer.observe(facetsRoot);

    window.addEventListener('scroll', this.boundScroll, { passive: true });
    document.addEventListener('click', this.boundDocumentClick, true);
    this.button.addEventListener('click', this.boundClick);
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.boundScroll);
    document.removeEventListener('click', this.boundDocumentClick, true);
    this.button?.removeEventListener('click', this.boundClick);
    this.observer?.disconnect();
  }

  onWindowScroll() {
    if (this.menuDrawerOpen) return;
    if (!this.pastFacets) return;
    if (this.matchesDisplayNone()) return;

    const y = window.scrollY || document.documentElement.scrollTop;
    const dy = y - this.lastScrollY;
    this.lastScrollY = y;

    if (dy < -5) {
      this.classList.add('collection-sticky-toolbar--revealed');
    } else if (dy > 8) {
      this.classList.remove('collection-sticky-toolbar--revealed');
    }
  }

  onDocumentClick(event) {
    const headerSummary = event.target.closest('header-drawer summary, .menu-drawer-container > details > summary');
    if (!headerSummary) return;

    const details = headerSummary.closest('details');
    const isOpening = !details?.hasAttribute('open') || !details?.classList.contains('menu-opening');
    this.menuDrawerOpen = isOpening;
    this.classList.remove('collection-sticky-toolbar--revealed');

    if (!isOpening) return;

    const resetWhenClosed = () => {
      if (!details?.hasAttribute('open') || !details?.classList.contains('menu-opening')) {
        this.menuDrawerOpen = false;
        window.removeEventListener('scroll', resetWhenClosed);
      }
    };

    window.addEventListener('scroll', resetWhenClosed, { passive: true });
  }

  matchesDisplayNone() {
    if (this.showDesktop) return false;
    return window.matchMedia('(min-width: 990px)').matches;
  }

  onButtonClick() {
    const drawer = this.facetsRoot.querySelector('menu-drawer');
    const summary =
      drawer?.querySelector('details.mobile-facets__disclosure > summary') || drawer?.querySelector('details > summary');
    if (summary) {
      summary.click();
    }
  }
}

customElements.define('collection-sticky-toolbar', CollectionStickyToolbar);
